import React from 'react';

export const RadioStateOffDefault = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <circle cx="12" cy="12" r="10.5" stroke="#90A0AF" strokeOpacity="0.5" strokeWidth="3" />
        </svg>
    );
};
